
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable vue/no-unused-properties */
	import Flickity, { data, FlickityEvents, Options } from 'flickity'
	import { defineComponent, onBeforeUnmount, onMounted, PropType, ref, watch } from 'vue'

	export default defineComponent({
		props: {
			options: {
				'type': Object as PropType<Options>,
				'required': false,
				'default': (): Options => ({}),
			},
		},

		emits: [
			'init',
		],

		setup(props, { emit }) {
			const rootElement = ref<Element | null>(null)
			let instance: Flickity | null = null

			const initialize = () => {
				if (rootElement.value !== null) {
					instance?.destroy()
					instance = new Flickity(rootElement.value, props.options)
					emit('init', instance)
				}
			}

			onMounted(initialize)

			watch(props, initialize)

			onBeforeUnmount(() => {
				instance?.destroy()
				instance = null
			})

			function on(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, cellElement?: Element, cellIndex?: number) => any): void
			function on(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, moveVector?: { x: number, y: number }) => any): void
			function on(eventname: FlickityEvents, callback: (event?: Event, cellElement?: Element) => any): void
			function on(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch) => any): void
			function on(eventname: FlickityEvents, callback: (index?: number) => any): void
			function on(eventname: FlickityEvents, callback: (isFullScreen?: boolean) => any): void
			function on(eventname: FlickityEvents, callback: () => any): void {
				instance?.on(eventname, callback)
			}

			function off(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, cellElement?: Element, cellIndex?: number) => any): void
			function off(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, moveVector?: Record<string, any>) => any): void
			function off(eventname: FlickityEvents, callback: (event?: Event, cellElement?: Element) => any): void
			function off(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch) => any): void
			function off(eventname: FlickityEvents, callback: (index?: number) => any): void
			function off(eventname: FlickityEvents, callback: (isFullScreen?: boolean) => any): void
			function off(eventname: FlickityEvents, callback: () => any): void {
				instance?.off(eventname, callback)
			}

			function once(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, cellElement?: Element, cellIndex?: number) => any): void
			function once(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch, moveVector?: Record<string, any>) => any): void
			function once(eventname: FlickityEvents, callback: (event?: Event, cellElement?: Element) => any): void
			function once(eventname: FlickityEvents, callback: (event?: Event, pointer?: Element | Touch) => any): void
			function once(eventname: FlickityEvents, callback: (index?: number) => any): void
			function once(eventname: FlickityEvents, callback: (isFullScreen?: boolean) => any): void
			function once(eventname: FlickityEvents, callback: () => any): void {
				instance?.once(eventname, callback)
			}

			return {
				rootElement,

				flickity: (): Flickity | null => instance,

				/**
				 * Selecting Slides
				 */
				select: (index: number, isWrapped?: boolean, isInstant?: boolean): void => instance?.select(index, isWrapped, isInstant),
				// next: (isWrapped?: boolean, isInstant?: boolean): void => instance?.next(isWrapped, isInstant),
				next: (isWrapped?: boolean): void => instance?.next(isWrapped),
				// previous: (isWrapped?: boolean, isInstant?: boolean): void => instance?.previous(isWrapped, isInstant),
				previous: (isWrapped?: boolean): void => instance?.previous(isWrapped),
				selectCell: (value: number, isWrapped?: boolean, isInstant?: boolean): void => instance?.selectCell(value, isWrapped, isInstant),

				/**
				 * Sizing and Positioning
				 */
				resize: (): void => instance?.resize(),
				reposition: (): void => instance?.reposition(),

				/**
				 * Adding and removing cells
				 */
				prepend: (elements: Element | Array<Element> | NodeList): void => instance?.prepend(elements),
				append: (elements: Element | Array<Element> | NodeList): void => instance?.append(elements),
				insert: (elements: Element | Array<Element> | NodeList, index: number): void => instance?.insert(elements, index),
				remove: (elements: Element | Array<Element> | NodeList): void => instance?.remove(elements),

				/**
				 * Player
				 */
				playPlayer: (): void => instance?.playPlayer(),
				stopPlayer: (): void => instance?.stopPlayer(),
				pausePlayer: (): void => instance?.pausePlayer(),
				unpausePlayer: (): void => instance?.unpausePlayer(),
				rerender: (): void => {
					instance?.destroy()
					initialize()
				},

				/**
				 * Utilities
				 */
				destroy: (): void => instance?.destroy(),
				reloadCells: (): void => instance?.reloadCells(),
				getCellElements: (): Array<Element> | undefined => instance?.getCellElements(),
				data: (): Flickity | null => (instance === null ? null : data(rootElement.value!)),

				/**
				 * Properties
				 */
				selectedElement: (): Element | undefined => instance?.selectedElement,
				selectedElements: (): Array<Element> | undefined => instance?.selectedElements,
				selectedIndex: (): number | undefined => instance?.selectedIndex,
				cells: (): Array<Element> | undefined => instance?.cells,
				slides: (): Array<Element> | undefined => instance?.slides,

				/**
				 * Events
				 */
				on,
				off,
				once,
			}
		},
	})
